import React from 'react'
import MediaItemImage from 'src/components/media/item/image'
import { MediaItemType } from 'src/model/media-directory'
import style from '../style'
import withStyles from '@material-ui/core/styles/withStyles'

const MediaGrid = ({ items, onSelect, dispatch, classes, refreshList }) => {
  if (!items || items.length === 0) {
    return (
      <div className={classes.entityNull}>
        <img src="/assets/editor-file/media/empty-media.svg" alt="" />
      </div>
    )
  }

  return (
    <div className={classes.imageList}>
      {items.map(mediaItem => (
        <MediaItemImage
          {...mediaItem}
          key={mediaItem.id}
          onSelect={onSelect}
          dispatch={dispatch}
          refreshList={refreshList}
          type={MediaItemType.IMAGE}
        />
      ))}
    </div>
  )
}

export default withStyles(style)(MediaGrid)
